export const API_KEY_PREFIX = "3b_sk_";

// Marks a member-modal user API key so the deprecated api-keys settings page
// hides it; the member modal strips the prefix for display.
export const USER_API_KEY_NAME_PREFIX = "userkey:";

// Marks a credential minted by the federated-token exchange; the suffix is the
// service_account_federations id, and queries use it to hide these keys.
export const FEDERATED_API_KEY_NAME_PREFIX = "federated:";

export const SESSION_API_KEY_NAME_PREFIX = "session:";
export const DEVICE_API_KEY_NAME_PREFIX = "device:";
